<template>
    <div id="homePage">
        <!-- <div class="banner clearfix">
            <img src="@/assets/images/logo.png" class="block left">
            <ul class="left clearfix">
                <li class="left">征稿</li>
            </ul>
        </div> -->
        <Menu topIndex="home"></Menu>
        <div class="contentBox">
            <div class="clearfix contentBox-top">
                <div class="title">在线填报</div>
                <el-button type="text"  class="save right" @click="saveManuscript">保存</el-button>
                <el-button type="text" @click="open" class="tianBaoShuoMing right">查看填报说明</el-button>
                <el-button type="text" @click="download" class="tianBaoShuoMing right">申请书下载</el-button>
            </div>
            <div class="contentFormBox">
                <div class="formBox formBox01">
                    <el-form ref="applyForm1" :model="applyForm1" :rules="applyRules1" label-width="110px">
                        <el-form-item label="所属系列：" class="applyFormSeries" prop="series">
                            <el-select v-model="applyForm1.series" placeholder="请选择所属系列">
                                <el-option label="人文社科系列" value="人文社科系列"></el-option>
                                <el-option label="科学技术系列" value="科学技术系列"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属学科：" class="applyFormSubject" prop="subject">
                            <el-input v-model="applyForm1.subject" placeholder="请输入所属学科"></el-input>
                        </el-form-item>
                        <p class="remarks">* 人文社科系列：涵盖哲学、历史学、文学、艺术学、语言学等人文学科，以及经济学、政治学、法学、社会学、管理学、教育学、新闻传播学等社会科学门类，鼓励理论创新、跨学科融合研究与实证研究。</p>
                        <p class="remarks" style="margin-bottom: 20px;">* 科学技术系列：涵盖数理化、天文、地学、生物学、信息科学、工程技术、医学、农业科学等自然科学与工程技术领域，特别关注交叉学科与前沿技术成果。</p>
                        <el-form-item label="成果名称：" prop="name">
                            <el-input v-model="applyForm1.name" placeholder="请输入成果名称"></el-input>
                        </el-form-item>
                        <el-form-item label="成果形式：" class='applyFormForm' prop="form">
                            <el-input v-model="applyForm1.form" placeholder="请输入成果形式"></el-input>
                        </el-form-item>
                        <el-form-item label="成果字数：" class='applyFormWords' prop="words">
                            <el-input v-model="applyForm1.words" placeholder="请输入成果字数">
                                <template slot="append">千字</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="申请人姓名：" class='applyFormApplyName' prop="applyName">
                            <el-input v-model="applyForm1.applyName" placeholder="请输入申请人姓名"></el-input>
                        </el-form-item>
                        <el-form-item class='applyFormWorkUnit' label="工作单位：" prop="workUnit" >
                            <el-input v-model="applyForm1.workUnit" placeholder="请输入工作单位（具体到院系所）"></el-input>
                        </el-form-item>
                        <el-form-item label="研究专长：" prop="speciality">
                            <el-input v-model="applyForm1.speciality" placeholder="请输入研究专长"></el-input>
                        </el-form-item>
                        <el-form-item class='applyFormIsJoin' label="是否参加过《中国大百科全书》的编纂工作：" label-width="310px" prop="isJoin">
                            <el-radio v-model="applyForm1.isJoin" label="Y">是</el-radio>
                            <el-radio v-model="applyForm1.isJoin" label="N">否</el-radio>
                        </el-form-item>
                        <el-form-item  v-if="applyForm1.isJoin == 'Y'" class='applyFormJoinName' label="参与《中国大百科全书》学科或专题的名称："  label-width="310px" prop="joinName">
                            <el-input v-model="applyForm1.joinName" placeholder="请输入参与《中国大百科全书》学科或专题的名称"></el-input>
                        </el-form-item>
                        <el-form-item v-if="applyForm1.isJoin == 'Y'" class='applyFormJoinRole' label="您在该学科或专题项目中担任的角色：" label-width="277px" prop="joinRole">
                            <el-checkbox-group v-model="roleResult">
                                <el-checkbox v-for="rule in roleGroups" :label="rule" :key="rule">{{rule}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="通讯地址：" class="applyFormAddress" prop="address">
                            <el-input v-model="applyForm1.address" placeholder="请输入通讯地址（请详细填写）"></el-input>
                        </el-form-item>
                        <el-form-item label="邮政编码：" class="applyFormZipCode" prop="zipCode">
                            <el-input v-model="applyForm1.zipCode" placeholder="请输入邮政编码"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="phone">
                            <el-input v-model="applyForm1.phone" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮件：" prop="email">
                            <el-input v-model="applyForm1.email" placeholder="请输入电子邮件"></el-input>
                        </el-form-item>
                        
                        <div class="page-box">
                            <el-button @click="toPage('next',1)">下一页</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="formBox formBox02 hidden">
                    <el-form ref="applyForm2" :model="applyForm2" :rules="applyRules2" label-width="95px">
                        <el-form-item
                            label="本成果主要合作者："
                            class="addInput addTable phoneCss"
                        >
                            <el-table
                                :data="collaboratorsTable"
                                border
                                style="width: 100%; margin-bottom: 20px"
                            >
                            <el-table-column prop="name" label="姓名"></el-table-column>
                            <el-table-column prop="speciality" label="研究专长"></el-table-column>
                            <el-table-column prop="unit" label="工作单位"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                <span @click="deleteTable(scope.row)" style="color: #409eff;cursor: pointer;"

                                    >删除</span
                                >
                                </template>
                            </el-table-column>
                            </el-table>
                            <el-button type="primary" style="float:right" @click="addCollaboratorsForm = {};addCollaboratorsDialog = true;"
                            >添加</el-button
                            >
                        </el-form-item>
                        <el-form-item class="phoneCss" label="申请人及主要合作者学术背景：" prop="background">
                            <el-input 
                                type="textarea"
                                v-model="applyForm2.background"
                                rows="10"
                                placeholder="请输入申请人及主要合作者学术背景（包括申请人及主要合作者自本科以来，各阶段的就读学校、院系、专业、导师等情况。）"></el-input>
                        </el-form-item>
                        <el-form-item class="phoneCss" label="成果情况：" prop="introduction">
                            <el-input 
                                type="textarea" 
                                v-model="applyForm2.introduction"
                                rows="10"
                                maxlength="2000"
                                show-word-limit
                                placeholder="请输入成果情况（1.请填写申报成果的主要研究方法、主要内容、主要建树、创新之处及学术意义或现实价值；2.字数控制在2000字以内。）" 
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="phoneCss" label="成果目录：" prop="catalog">
                            <el-input 
                                type="textarea" 
                                v-model="applyForm2.catalog"
                                rows="10"
                                placeholder="请填写申报成果的目录。" 
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="phoneCss" label="主要参考文献：" prop="reference"  label-width="90px" >
                            <el-input 
                                type="textarea" 
                                v-model="applyForm2.reference"
                                rows="10"
                                placeholder="请填写申报成果的主要参考文献。" 
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="page-box">
                        <el-button @click="toPage('pre',2)">上一页</el-button>
                        <el-button @click="toPage('next',2)">下一页</el-button>
                    </div>
                </div>
                <div class="formBox formBox03 hidden">
                    <el-form ref="applyForm3" :model="applyForm3" :rules="applyRules3" label-width="30%">
                        <el-form-item
                            label="专家推荐意见："
                            class="addInput addTable phoneCss"
                        >
                            <el-upload
                                class="upload-demo"
                                ref="expertOpinionUpload"
                                :action="updateUrl"
                                :on-success="expertOpinionSuccess"
                                :before-upload="beforePdfUpload"
                                :file-list="expertOpinionFileList"
                                name="upfiles"
                                accept=".pdf"
                                :limit = "1"
                                :on-exceed="handleExceed"
                                :on-change="handleExpertOpinionFileChange"
                                :on-remove="handleExpertOpinionRemove"
                                :data="dataForm">
                                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="expertOpinionSubmitUpload">上传到服务器</el-button> -->
                                <div slot="tip" class="el-upload__tip">* 只能上传pdf文件，重复上传的PDF文件替换当前文件</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item class="phoneCss" label="所在单位意见：">
                            <el-upload
                                class="upload-demo"
                                ref="unitOpinionUpload"
                                :action="updateUrl"
                                :on-success="unitOpinionSuccess"
                                :before-upload="beforePdfUpload"
                                :file-list="unitOpinionFileList"
                                name="upfiles"
                                accept=".pdf"
                                :limit = "1"
                                :data="dataForm"
                                :on-exceed="handleExceed"
                                :on-change="handleUnitOpinionFileChange"
                                :on-remove="handleUnitOpinionRemove">
                                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="unitOpinionSubmitUpload">上传到服务器</el-button> -->
                                <div slot="tip" class="el-upload__tip">* 只能上传pdf文件，重复上传的PDF文件替换当前文件</div>
                            </el-upload>
                            </el-form-item>
                        <el-form-item class="phoneCss" label="承诺书：" prop="commitment">
                            <el-upload
                                class="upload-demo"
                                ref="commitmentUpload"
                                :action="updateUrl"
                                :on-success="commitmentSuccess"
                                :before-upload="beforePdfUpload"
                                :file-list="commitmentFileList"
                                name="upfiles"
                                accept=".pdf"
                                :limit = "1"
                                :data="dataForm"
                                :on-exceed="handleExceed"
                                :on-change="handleCommitmentFileChange"
                                :on-remove="handleCommitmentRemove">
                                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="commitmentSubmitUpload">上传到服务器</el-button> -->
                                <div slot="tip" class="el-upload__tip">* 只能上传pdf文件，重复上传的PDF文件替换当前文件</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item class="phoneCss" label="书稿稿件上传：" prop="manuscript">
                            <el-upload
                                class="upload-demo"
                                ref="manuscriptUpload"
                                :action="updateUrl"
                                :on-success="manuscriptSuccess"
                                :before-upload="beforeWordUpload"
                                :file-list="manuscriptFileList"
                                name="upfiles"
                                accept=".docx,.doc,"
                                :limit = "1"
                                :data="dataForm"
                                :on-exceed="handleExceed"
                                :on-change="handleManuscriptFileChange"
                                :on-remove="handleManuscriptRemove">
                                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="manuscriptSubmitUpload">上传到服务器</el-button> -->
                                <div slot="tip" class="el-upload__tip" style="line-height: 1.5em;">* 成稿率要求：（1）独著须提供全部书稿；（2）多卷本须提供不少于90%的书稿；（3）丛书类成果须提供不少于60%的书稿，且各单册均须提供不少于60%的书稿。</div>
                                <div slot="tip" class="el-upload__tip" style="line-height: 1.5em;">* 篇幅格式要求：简体中文横排，word格式；如有图片，请标注图号、图题，另设文件夹提交原图上传功能。正文字数在10万-25万字为宜，体例规范、注释统一、符合出版要求；图片、表格、公式等清晰规范。</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item class="phoneCss" label="查重报告上传：" prop="checkReport">
                            <el-upload
                                class="upload-demo"
                                ref="checkReportUpload"
                                :action="updateUrl"
                                :on-success="checkReportSuccess"
                                :before-upload="beforePdfUpload"
                                :file-list="checkReportFileList"
                                name="upfiles"
                                accept=".pdf"
                                :limit = "1"
                                :data="dataForm"
                                :on-exceed="handleExceed"
                                :on-change="handleCheckReportFileChange"
                                :on-remove="handleCheckReportRemove">
                                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="checkReportSubmitUpload">上传到服务器</el-button> -->
                                <div slot="tip" class="el-upload__tip" style="line-height: 1.5em;">* 查重要求：请投稿作者提供权威平台出具的查重报告。</div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div class="page-box">
                        <el-button @click="toPage('pre',3)">上一页</el-button>
                        <el-button @click="toPage('next',3)">下一页</el-button>
                    </div>
                </div>
                <div class="formBox formBox04 hidden">
                    <el-form ref="applyForm4" :model="applyForm4" label-width="30%">
                        <el-form-item
                            label="稿件所含图片的原图上传："
                            class="addInput addTable phoneCss"
                        >
                        <el-upload
                                    class="upload-demo"
                                    ref="imageUpload"
                                    action=""
                                    :auto-upload="false"
                                    :file-list="imgFileList"
                                    :on-change="handleImgFileChange"
                                    :before-upload="imgBeforeUpload"
                                    name="upfiles"
                                    list-type="picture"
                                    accept=".jpg,.png"
                                    :limit="50"
                                    :on-exceed="imgHandleExceed"
                                    multiple
                                    :on-remove="handleImgRemove"
                                    :on-progress="handleImgProgress"
                                    :disabled="isUploading">
                                    <el-button
                                        slot="trigger"
                                        size="small"
                                        type="primary"
                                        :disabled="isUploading">
                                        {{ isUploading ? '上传中...' : '上传图片' }}
                                    </el-button>
                                    <div slot="tip" class="el-upload__tip" style="line-height: 1.5em;">* 图片上传只能是jpg,png格式，总图片数小于等于50张，每次批量上传图片数小于等于10张。</div>
                                </el-upload>
                        </el-form-item>
                    </el-form>
                    <div class="page-box">
                        <el-button @click="toPage('pre',4)">上一页</el-button>
                        <el-button  class="submitButton" @click="submitCheckDialog = true">提交申报</el-button>
                    </div>
                </div>
            </div>
        </div>

        
          <!-- 添加添加本成果主要合作者弹窗 -->
          <el-dialog
            title="添加本成果主要合作者"
            :visible.sync="addCollaboratorsDialog"
            width="600px"
            class="CollaboratorsDialog"
          >
            <el-form
              ref="addCollaboratorsForm"
              :model="addCollaboratorsForm"
              style="padding: 10px"
              label-width="130px"
            >
              <el-form-item
                label="姓名："
                class="addInput phoneCss"
                style="width: 95%"
              >
                <el-input
                  v-model="addCollaboratorsForm.name"
                  placeholder="请输入姓名"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="研究专长："
                class="addInput phoneCss"
                style="width: 95%"
              >
                <el-input
                  v-model="addCollaboratorsForm.speciality"
                  placeholder="请输入研究专长"
                ></el-input
              ></el-form-item>
              <el-form-item
                label="工作单位："
                class="addInput phoneCss"
                style="width: 95%"
              >
                <el-input
                  type="textarea"
                  v-model="addCollaboratorsForm.unit"
                  placeholder="请输入工作单位（具体到研究室或院系）"
                ></el-input></el-form-item
            ></el-form>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button
                type="primary"
                @click="checkAddChronology('addCollaboratorsForm')"
                >确 定
              </el-button>
              <el-button @click="addCollaboratorsDialog = false">取 消</el-button>
            </span></el-dialog
          >
          
            <!-- 提交确认弹窗 -->
            <el-dialog title="提交确认" :visible.sync="submitCheckDialog" width="30%" center>
            <div>提交后无法修改，是否确定提交该申请？</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitManuscript()">确 定</el-button>
                <el-button @click="submitCheckDialog = false">取 消</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
  import '@/assets/css/index.css';
  import Menu from "@/views/component/topMenu.vue";
  import $ from 'jquery'; 
  
  export default {
    data() {
        
        // 电话验证：支持 手机号 + 固定电话（含区号、分隔符）
        var validateTelAdd = (rule, value, callback) => {
        // 为空不校验
        if (value === "" || value == undefined) {
            callback();
            return;
        }
        // 去除首尾空格
        const tel = value.trim();
        /**
         * 正则说明：
         * 1. 手机号：^1[3-9]\d{9}$  国内11位手机号
         * 2. 固定电话：
         *    格式1：0XXX-XXXXXXX / 0XX-XXXXXXXX （带区号+横杠）
         *    格式2：纯数字固定电话（无区号/横杠）
         */
        const regMobile = /^1[3456789]\d{9}$/;
        const regLandline = /^(0\d{2,3}-?)?\d{7,8}$/;

        if (regMobile.test(tel) || regLandline.test(tel)) {
            callback();
        } else {
            callback(new Error("请输入正确的手机号或固定电话"));
        }
        };
        
      return {
        applyForm: {},
        applyForm1: {
            series: '',
            subject: '',
            name: '',
            form: '',
            words: '',
            applyName: '',
            speciality: '',
            workUnit: '',
            address: '',
            zipCode: '',
            phone: '',
            email: '',
            isJoin:'N',
            joinName:'',
            // 新增：复选框组初始化为空数组
            joinRole: []
        },
        applyForm2: {},
        applyForm3: {},
        applyForm4: {},
        roleGroups: ['主编','副主编','分支主编','分支副主编','撰稿人','其他'],
        roleResult:[],
        collaboratorsTable:[],
        addCollaboratorsDialog:false,
        submitCheckDialog:false,
        addCollaboratorsForm:{},
        expertOpinionFileList: [],
        unitOpinionFileList: [],
        commitmentFileList: [],
        manuscriptFileList: [],
        checkReportFileList: [],
        imgFileList: [],
        imgContentList:[],
        isUploading: false,
        submitFlag:true,
        userData: '',
        actId: '',
        dataForm:{},
        isEdit:false,
        actList:[],
        // bkwWeb:"https://test.zgbk.com",//测试环境地址
        bkwWeb:"https://www.zgbk.com",//正式环境地址
        zxzgUrl:'/zxzg',
        updateUrl:'/zxzg/api/vh/free/upload/attachments',
        resourceUrl:'/resource',
        applyRules1:{
            series: [{ required: true, message: '请选择所属系列',trigger: 'change'}],
            subject: [{ required: true, message: '请输入所属学科',trigger: 'change'}],
            name: [{ required: true, message: '请输入成果名称',trigger: 'change'}],
            form: [{ required: true, message: '请输入成果形式',trigger: 'change'}],
            words: [
                { required: true,  message: '请输入成果字数',trigger: 'change'},
                // { type: 'number', message: '成果字数必须为数字值',trigger: 'blur' }
            ],
            applyName: [{ required: true, message: '请输入申请人姓名',trigger: 'change'}],
            speciality: [{ required: true, message: '请输入研究专长',trigger: 'change'}],
            isJoin: [{ required: true, trigger: 'change',message: '请选择是否参加过《中国大百科全书》的编纂工作'}],
            joinName: [{ 
                required: true, 
                message: '请输入参与《中国大百科全书》学科或专题的名称', 
                trigger: 'blur',
                // 动态控制是否启用校验
                validator: (rule, value, callback) => {
                    if (this.applyForm1.isJoin === 'Y' && !value) {
                        callback(new Error('请输入参与《中国大百科全书》学科或专题的名称'));
                    } else {
                        callback();
                    }
                }
            }],

            // 动态必填：角色复选框
            joinRole: [{
                required: true, 
                message: '请至少选择一项担任角色', 
                trigger: 'change',
                validator: (rule, value, callback) => {
                    // 选【是】时，数组为空则校验不通过
                    if (this.applyForm1.isJoin === 'Y' && this.roleResult.length === 0) {
                        callback(new Error('请至少选择一项担任角色'));
                    } else {
                        callback();
                    }
                },
             }],
            workUnit: [{ required: true, message: '请输入工作单位',trigger: 'change'}],
            address: [{ required: true, message: '请输入通讯地址',trigger: 'change'}],
            zipCode: [
                { required: true,  message: '请输入邮编',trigger: 'change'},
                { min: 6, max: 6, message: '邮编必须为6位',trigger: 'change'}

            ],
            phone: [
                { required: true, message: "请输入电话",trigger: 'change'},
                { validator: validateTelAdd, message: "请输入正确的电话格式"}
            ],
            email: [
                { required: true, message: '请输入邮箱地址',trigger: 'change'},
                { type: 'email', message: '请输入正确的邮箱地址',trigger: 'change'}
            ],
        },
        applyRules2:{
            background: [{ required: true, message: '请输入学术背景',trigger: 'change'}],
            introduction: [{ required: true, message: '请输入成果情况',trigger: 'change'}],
            reference: [{ required: true, message: '请输入参考文献',trigger: 'change'}],
            catalog: [{ required: true, message: '请输入成果目录',trigger: 'change'}],
        },
        applyRules3:{
            expertOpinion: [
                { required: true, validator: (rule, value, callback) => {
                    if(this.expertOpinionFileList.length === 0){
                        callback(new Error('请上传专家推荐意见PDF'))
                    }else{
                        callback()
                    }
                }}
            ],
            unitOpinion: [
                { required: true, validator: (rule, value, callback) => {
                    if(this.unitOpinionFileList.length === 0){
                        callback(new Error('请上传所在单位意见PDF'))
                    }else{
                        callback()
                    }
                }}
            ],
            commitment: [
                { required: true, validator: (rule, value, callback) => {
                    if(this.commitmentFileList.length === 0){
                        callback(new Error('请上传承诺书PDF'))
                    }else{
                        callback()
                    }
                }}
            ],
            manuscript: [
                { required: true, validator: (rule, value, callback) => {
                    if(this.manuscriptFileList.length === 0){
                        callback(new Error('请上传书稿Word文件'))
                    }else{
                        callback()
                    }
                }}
            ],
            checkReport: [
                { required: true, validator: (rule, value, callback) => {
                    if(this.checkReportFileList.length === 0){
                        callback(new Error('请上传查重报告PDF'))
                    }else{
                        callback()
                    }
                }}
            ]
        },
        applyRules:{
            series: [{ required: true, message: '请选择所属序列',trigger: 'change'}],
            subject: [{ required: true, message: '请输入所属学科',trigger: 'change'}],
            zipCode: [
                { required: true,  message: '请输入邮编',trigger: 'change'},
                // { type: 'number', message: '邮编必须为数字值',trigger: 'blur' },
                { min: 6, max: 6, message: '邮编必须为6位',trigger: 'change'}

            ],
            address: [{ required: true, message: '请输入通讯地址',trigger: 'change'}],
            speciality: [{ required: true, message: '请输入研究专长',trigger: 'change'}],
            applyName: [{ required: true, message: '请输入申请人姓名',trigger: 'change'}],
            form: [{ required: true, message: '请输入成果形式',trigger: 'change'}],
            name: [{ required: true, message: '请输入成果名称',trigger: 'change'}],
            workUnit: [{ required: true, message: '请输入工作单位',trigger: 'change'}],
            background: [{ required: true, message: '请输入学术背景',trigger: 'change'}],
            introduction: [{ required: true, message: '请输入成果情况',trigger: 'change'}],
            reference: [{ required: true, message: '请输入参考文献',trigger: 'change'}],
            catalog: [{ required: true, message: '请输入成果目录',trigger: 'change'}],
            phone: [
                { required: true, message: "请输入电话",trigger: 'change'},
                { validator: validateTelAdd, message: "请输入正确的电话格式"}
            ],
            email: [
                { required: true, message: '请输入邮箱地址',trigger: 'change'},
                { type: 'email', message: '请输入正确的邮箱地址',trigger: 'change'}
            ],
        }
      }
    },
    components: {
        Menu,
    },
    mounted() {
        document.title = '在线申报';
        var that = this;
        var historyData = localStorage.getItem('historyData');
        var getDataUrl = this.bkwWeb + '/ecph/dk/encode/data'
        var isHistory = historyData && historyData != ""
                
        // this.userData = '9apV+UOuIx0F9WAh+5G4yq/8Cvx8XB3sf0OJd9i/VwuzPNWgosMLDs1lWaqyZwKiQa73exqQ5ELXl3QJmSYz/Q==';
        // this.dataForm.data = '9apV+UOuIx0F9WAh+5G4yq/8Cvx8XB3sf0OJd9i/VwuzPNWgosMLDs1lWaqyZwKiQa73exqQ5ELXl3QJmSYz/Q==';
        // 获取活动
        $.ajax({
            url: '/zxzg/api/vh/free/act/actInfo/list',
            type: "GET",
            dataType: "json",
            error: (xhr) => {
                if (xhr.status == 401) window.location.reload();
                else console.error('请求失败',xhr);
            },
            success: (data) => {
                if(data.code === 200) {
                     this.actId = data.obj.list[0].id;
                     this.actList = data.obj.list[0].attachmentList
                }else{
                    this.$message({
                        message: data.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            }
        })
        // 获取登录信息
        $.ajax({
            url: getDataUrl,
            type: "POST",
            dataType: "json",
            xhrFields: {withCredentials:true},
            crossDomain:true,
            error: (xhr) => {
                if (xhr.status == 401) window.location.reload();
                else console.error('请求失败',xhr);
            },
            success: (data) => {
                if(data.code === 200) {
                    this.userData = data.data;
                    this.dataForm.data = data.data;
                    this.open();
                }else{
                    this.$alert('当前为未登录状态，请登录后再进行填报', '提示', {
                        confirmButtonText: '确定',
                        customClass: 'logoutAlertBox',
                        type: 'warning',
                        center: true,
                        callback: () => {
                            window.location.href = this.bkwWeb + '/sso/oauth/changeperson';
                        }
                    });


                    // 1. 新开窗口跳转登录/切换账号页面
                    // const targetUrl = this.bkwWeb + '/sso/oauth/changeperson';
                    // const newWin = window.open(targetUrl);
                    
                    // // 2. 浏览器拦截弹窗判断提示
                    // if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                    //     this.$message({
                    //     message: '页面跳转被浏览器拦截，请允许弹窗或手动访问：' + targetUrl,
                    //     duration: 0,
                    //     showClose: true,
                    //     type: "warning",
                    //     offset: 100,
                    //     });
                    // } else {
                    //     this.$message({
                    //     message: data.msg,
                    //     duration: 0,
                    //     showClose: true,
                    //     type: "error",
                    //     offset: 100,
                    //     });
                    // }
                }
            }
        })
        var sid = this.getUrlParam('sid');
        if(sid && sid != "" && !isHistory){//判断是否为编辑
            this.isEdit = true;
            $.ajax({
                url: '/zxzg/api/vh/free/act/submitInfo/get',
                type: "POST",
                dataType: "json",
                data: {
                    sid: sid,
                },
                error: (xhr) => {
                    if (xhr.status == 401) window.location.reload();
                    else console.error('请求失败',xhr);
                },
                success: (data) => {
                    if(data.code === 200) {
                        this.applyForm1 = {
                            actId: data.obj.actId,
                            sid: data.obj.sid,
                            series: data.obj.series,
                            subject: data.obj.subject,
                            zipCode: data.obj.zipCode,
                            address: data.obj.address,
                            speciality: data.obj.speciality,
                            applyName: data.obj.applyName,
                            form: data.obj.form,
                            name: data.obj.name,
                            workUnit: data.obj.workUnit,
                            phone: data.obj.phone,
                            email: data.obj.email,
                            words: data.obj.words,
                            isJoin: data.obj.isJoin,
                        };
                        if(data.obj.isJoin == 'Y' && data.obj.joinName && data.obj.joinRole){
                            this.applyForm1.joinName = data.obj.joinName
                            this.applyForm1.joinRole = data.obj.joinRole
                            this.roleResult = data.obj.joinRole.split(',')
                        }
                        this.applyForm2 = {
                            background: data.obj.background,
                            catalog: data.obj.catalog,
                            introduction: data.obj.introduction,
                            reference: data.obj.reference,
                        };
                        this.applyForm3 = {
                            expertOpinion: data.obj.expertOpinion,
                            unitOpinion: data.obj.unitOpinion,
                            commitment: data.obj.commitment,
                            checkReport: data.obj.checkReport,
                            manuscript: data.obj.manuscript,
                        };
                        this.collaboratorsTable = data.obj.coauthorList;
                        let fileMap = data.obj.fileMap;
                        for(let key in fileMap){//获取文件资源
                            if(key === data.obj.expertOpinion){
                                this.expertOpinionFileList = [
                                    {name:fileMap[key].fileName,url:this.resourceUrl+fileMap[key].resourcePath}
                                ]
                            }else if(key === data.obj.unitOpinion){
                                this.unitOpinionFileList = [
                                    {name:fileMap[key].fileName,url:this.resourceUrl+fileMap[key].resourcePath}
                                ]
                            }else if(key === data.obj.commitment){
                                this.commitmentFileList = [
                                    {name:fileMap[key].fileName,url:this.resourceUrl+fileMap[key].resourcePath}
                                ]
                            }else if(key === data.obj.checkReport){
                                this.checkReportFileList = [
                                    {name:fileMap[key].fileName,url:this.resourceUrl+fileMap[key].resourcePath}
                                ]
                            }else if(key === data.obj.manuscript){
                                this.manuscriptFileList = [
                                    {name:fileMap[key].fileName,url:this.resourceUrl+fileMap[key].resourcePath}
                                ]
                            }
                        }
                    }else{
                        this.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                    }
                }
            })

            $.ajax({//获取图片资源
                url: '/zxzg/api/vh/free/act/submitResource/list',
                type: "POST",
                dataType: "json",
                data: {
                    sid: sid,
                    page: 1,
                    size:50
                },
                error: (xhr) => {
                    if (xhr.status == 401) window.location.reload();
                    else console.error('请求失败',xhr);
                },
                success: (data) => {
                    if(data.code === 200) {
                        that.imgContentList = data.obj.list;
                        if(data.obj.list && data.obj.list.length > 0){
                            data.obj.list.forEach((item) => {
                                that.imgFileList.push({
                                    name: item.oldName,
                                    url: that.resourceUrl + item.resourcePath
                                })
                            })
                        }
                    }else{
                        this.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                    }
                }
            })

        }else if(isHistory){//判断保存历史数据是否为空
            this.isEdit = true;
            this.applyForm = JSON.parse(historyData);
            this.applyForm1 = {
                actId: this.applyForm.actId,
                sid: this.applyForm.sid,
                series: this.applyForm.series,
                subject: this.applyForm.subject,
                zipCode: this.applyForm.zipCode,
                address: this.applyForm.address,
                speciality: this.applyForm.speciality,
                applyName: this.applyForm.applyName,
                form: this.applyForm.form,
                name: this.applyForm.name,
                workUnit: this.applyForm.workUnit,
                phone: this.applyForm.phone,
                email: this.applyForm.email,
                words: this.applyForm.words,
                isJoin: this.applyForm.isJoin,
            };
            
            if(this.applyForm1.isJoin == 'Y'){
                this.applyForm1.joinName = this.applyForm.joinName
                this.applyForm1.joinRole = this.applyForm.joinRole
                this.roleResult = this.applyForm.joinRole.split(',')
            }
            this.applyForm2 = {
                background: this.applyForm.background,
                catalog: this.applyForm.catalog,
                introduction: this.applyForm.introduction,
                reference: this.applyForm.reference,
            };    
            // 第四页
            this.applyForm4 = {};

            if(localStorage.getItem('expertOpinionFileList') && JSON.parse(localStorage.getItem('expertOpinionFileList')).length > 0){
                this.expertOpinionFileList = JSON.parse(localStorage.getItem('expertOpinionFileList'));
                this.applyForm3.expertOpinion = this.expertOpinionFileList[0].response ? this.expertOpinionFileList[0].response.obj[0].sid : this.applyForm.expertOpinion
            }
            if(localStorage.getItem('commitmentFileList') && JSON.parse(localStorage.getItem('commitmentFileList')).length > 0){
                this.commitmentFileList = JSON.parse(localStorage.getItem('commitmentFileList'));
                this.applyForm3.commitment = this.commitmentFileList[0].response ? this.commitmentFileList[0].response.obj[0].sid : this.applyForm.commitment

            }
            if(localStorage.getItem('unitOpinionFileList') && JSON.parse(localStorage.getItem('unitOpinionFileList')).length > 0){
                this.unitOpinionFileList = JSON.parse(localStorage.getItem('unitOpinionFileList'));
                this.applyForm3.unitOpinion = this.unitOpinionFileList[0].response ? this.unitOpinionFileList[0].response.obj[0].sid : this.applyForm.unitOpinion
            }
            if(localStorage.getItem('manuscriptFileList') && JSON.parse(localStorage.getItem('manuscriptFileList')).length > 0){
                this.manuscriptFileList = JSON.parse(localStorage.getItem('manuscriptFileList'));
                this.applyForm3.manuscript = this.manuscriptFileList[0].response ? this.manuscriptFileList[0].response.obj[0].sid : this.applyForm.manuscript
            }
            if(localStorage.getItem('checkReportFileList') && JSON.parse(localStorage.getItem('checkReportFileList')).length > 0){
                this.checkReportFileList = JSON.parse(localStorage.getItem('checkReportFileList'));
                this.applyForm3.checkReport = this.checkReportFileList[0].response ? this.checkReportFileList[0].response.obj[0].sid : this.applyForm.checkReport
            }
            if(localStorage.getItem('imgFileList') && localStorage.getItem('imgFileList').length > 0){
                this.imgFileList = JSON.parse(localStorage.getItem('imgFileList'));
            }        
            if(localStorage.getItem('collaboratorsTable') && localStorage.getItem('collaboratorsTable').length > 0){
                this.collaboratorsTable = JSON.parse(localStorage.getItem('collaboratorsTable'));
            }
        }else{
            this.isEdit = false;
        }
        
        this.$nextTick(() => {
            const inputElement = this.$refs.imageUpload.$el.querySelector('input[type="file"]');
            if (inputElement) {
                inputElement.addEventListener('change', this.handleNativeFileChange);
            }
        });
    },
    beforeDestroy() {
        const inputElement = this.$refs.imageUpload?.$el.querySelector('input[type="file"]');
        if (inputElement) {
            inputElement.removeEventListener('change', this.handleNativeFileChange);
        }
    },
    methods: {
        open() {
            this.$alert(
                '<div class="explanation"><p>1.各项内容请严肃、认真、如实填写，内容超出表格可附页。</p>'+
                '<p>2.“成果名称”须填写全称，“成果形式”主要包括学术专著、科普读物、工具书等</p>'+
                '<p>3.“专家推荐意见”须由两名与申报成果学科相关、具有副高级专业技术职务的专家填写。推荐专家不得是申报成果的合作者。</p>'+
                '<p>4.申请人须签署表格后附的《承诺书》。</p>'+
                '<p>5.表格内签字或盖章处，须亲笔签字或加盖公章。</p>'+
                '<p>6.除签章外，各项内容均使用计算机填写，并用A4纸双面打印，左侧装订。</p></div>',
                '填写说明', 
                {
                    dangerouslyUseHTMLString: true,
                    showClose:false,
                }
            );
        },

        // 申请书下载
        download(){
            window.open("/zxzg/api/vh/free/act/submitInfo/download?sid=" + encodeURIComponent(this.actList[0].sid), '_blank');
        },

                // 判断整个表单是否全部为空（三个值全都空）
        isCollaboratorEmpty() {
            const { name, speciality, unit } = this.addCollaboratorsForm;
            return !name && !speciality && !unit;
        },
      
        // 添加本成果主要合作者确认
        checkAddChronology() {
            if(!this.isCollaboratorEmpty()){
                this.collaboratorsTable.push(this.addCollaboratorsForm);
                this.addCollaboratorsDialog = false;
            }else{
                 return this.$message.error("请先添加合作者信息")
            }
        },
        // 分页
        toPage(current,page){
            switch (current) {
                case "pre":
                    $(".formBox0"+(page-1)).show();
                    $(".formBox0"+(page-1)).siblings(".formBox").hide();
                    break;

                case "next":
                    $(".formBox0"+(page+1)).show();
                    $(".formBox0"+(page+1)).siblings(".formBox").hide();
                    break;

                default:
                    break;
            }
        },
        // 投稿提交
        async submitManuscript() {
            if (this.isUploading) {
                this.$message({
                    message: "图片上传中，请稍后再提交申报。",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                return;
            }else{

            if(this.applyForm1.isJoin == 'Y'){
                this.applyForm1.joinRole = this.roleResult.toString();
            }else if(this.applyForm1.isJoin == 'N'){
                // 直接删除两个属性
                delete this.applyForm1.joinName;
                delete this.applyForm1.joinRole;
            }
            // 1. 逐页校验
            const pass1 = await this.checkPage1();
            if (!pass1) {
                this.$message({
                    message: "第一页存在未填写的必填项，请检查红色提示",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                return;
            }

            const pass2 = await this.checkPage2();
            if (!pass2) {
                this.$message({
                    message: "第二页存在未填写的必填项，请检查红色提示",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                return;
            }

            const pass3 = await this.checkPage3();
            if (!pass3) {
                this.$message({
                    message: "第三页文件未全部上传，请检查上传项",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                return;
            }

            // 全部校验通过，合并表单对象
            this.applyForm = Object.assign({}, this.applyForm1, this.applyForm2, this.applyForm3, this.applyForm4);

            // 拼装额外参数
            if (this.collaboratorsTable.length) {
                this.applyForm.coauthors = JSON.stringify(this.collaboratorsTable);
            }
            if (this.imgContentList.length > 0) {
                let ids = this.imgContentList.map(item => item.sid);
                this.applyForm.imageIds = ids.join(',');
            }
            this.applyForm.adata = this.userData;
            this.applyForm.actId = this.actId;
            
            let that = this;
            // 第一步保存草稿
            $.ajax({
                url: '/zxzg/api/vh/free/act/submitInfo/save',
                type: "POST",
                dataType: "json",
                data: this.applyForm,
                error: function (xhr) {
                if (xhr.status == 401) window.location.reload();
                },
                success: function (data) {
                if (data.code == 200) {
                    // 第二步正式提交
                    $.ajax({
                    url: '/zxzg/api/vh/free/act/submitInfo/submit',
                    type: "POST",
                    dataType: "json",
                    data: { sid: data.obj },
                    error: function (xhr) {
                        if (xhr.status == 401) window.location.reload();
                    },
                    success: function (res) {
                        if (res.code == 200) {
                        that.$message({
                            message: res.msg,
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        // 清空所有表单与缓存
                        that.applyForm = {}
                        that.applyForm1 = {}
                        that.applyForm2 = {}
                        that.applyForm3 = {}
                        that.applyForm4 = {}
                        that.expertOpinionFileList = [];
                        that.commitmentFileList = [];
                        that.unitOpinionFileList = [];
                        that.checkReportFileList = [];
                        that.checkReportFileList = [];
                        that.imgFileList = [];
                        that.collaboratorsTable = [];
                        localStorage.setItem('historyData','');
                        localStorage.setItem('expertOpinionFileList', '');
                        localStorage.setItem('unitOpinionFileList', '');
                        localStorage.setItem('commitmentFileList', '');
                        localStorage.setItem('manuscriptFileList', '');
                        localStorage.setItem('checkReportFileList', '');
                        localStorage.setItem('imgFileList', '');
                        localStorage.setItem('collaboratorsTable', '');
                        that.submitCheckDialog = false;
                        window.open(that.bkwWeb + '/ecph/member/zxzg?current=memberZxzg&SiteID=1', '_blank')
                        } else {
                        that.$message({
                            message: res.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });
                        }
                    },
                    });
                } else {
                    const checkArr = data.msg.split(',');
                    if (checkArr.length > 0) {
                    that.$message({
                        message: `<div style="line-height:2em">${checkArr.join('<br>')}</div>`,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                        dangerouslyUseHTMLString: true
                    });
                    } else {
                    that.$message({
                        message: data.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                    }
                }
                },
            });
            }
        },

        beforePdfUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 100;
            if (!isLt2M) {
                this.$message.error("资源超过上传上限100MB，如仍需上传，请联系管理员。");
                return isLt2M;
            }
              // 2. 格式校验
            const suffix = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (suffix !== '.pdf') {
                this.$message.error('仅允许上传 .pdf 格式文件');
                return false;
            }
            // 3. 空文件校验
            if (file.size <= 0) {
                this.$message.error('禁止上传空文件');
                return false;
            }
        },
        beforeWordUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 100;
            if (!isLt2M) {
                this.$message.error("资源超过上传上限100MB，如仍需上传，请联系管理员。");
                return isLt2M;
            }
              // 2. 格式校验
            const suffix = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (suffix !== '.doc' && suffix !== '.docx') {
                this.$message.error('仅允许上传.doc或者.docx格式文件');
                return false;
            }
            // 3. 空文件校验
            if (file.size <= 0) {
                this.$message.error('禁止上传空文件');
                return false;
            }
        },

        imgBeforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 100;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过100MB!');
                return isLt2M;
            }
            // 2. 格式校验
            const suffix = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (suffix !== '.png' && suffix !== '.jpg') {
                this.$message.error('仅允许上传.jpg或者.png格式文件');
                return false;
            }
            // 3. 空文件校验
            if (file.size <= 0) {
                this.$message.error('禁止上传空文件');
                return false;
            }
        },

        
        handleExceed() {
            this.$message({
                message: `当前限制选择 1 个文件，已存在一个文件，请确认删除后再进行上传。`,
                duration: 5000,
                showClose: true,
                type: "warning",
                offset: 100,
            });
        },
        
        imgHandleExceed(files, fileList) {
            this.imgFileList = this.imgFileList.filter(item => item.isUploaded);
            this.$message({
                message: `总图片数小于等于50张，每次批量上传图片数小于等于10张，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length} 个图片`,
                duration: 5000,
                showClose: true,
                type: "warning",
                offset: 100,
            });
        },
        
        // 专家意见上传成功钩子
        expertOpinionSuccess(response) {
            let that = this;
            if(response.code == 200){
                that.applyForm3.expertOpinion = response.obj[0].sid;
                that.$message({
                    message: "专家意见"+response.msg,
                    duration: 2000,
                    showClose: true,
                    type: "success",
                    offset: 100,
                });
            }else{
                that.$message({
                message:response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
        },
        // 单位意见上传成功钩子
        unitOpinionSuccess(response) {
            let that = this;
            if(response.code == 200){
                that.applyForm3.unitOpinion = response.obj[0].sid;
                that.$message({
                message: "单位意见"+response.msg,
                duration: 2000,
                showClose: true,
                type: "success",
                offset: 100,
                });
            }else{
                that.$message({
                message:response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
        },
        // 承诺书上传成功钩子
        commitmentSuccess(response) {
            let that = this;
            if(response.code == 200){
                that.applyForm3.commitment = response.obj[0].sid;
                that.$message({
                message: "承诺书"+response.msg,
                duration: 2000,
                showClose: true,
                type: "success",
                offset: 100,
                });
            }else{
                that.$message({
                message:response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
        },
        // 书稿上传成功钩子
        manuscriptSuccess(response) {
            let that = this;
            if(response.code == 200){
                that.applyForm3.manuscript = response.obj[0].sid;
                that.$message({
                message: "书稿"+response.msg,
                duration: 2000,
                showClose: true,
                type: "success",
                offset: 100,
                });
            }else{
                that.$message({
                message:response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
        },
        // 查重报告上传成功钩子
        checkReportSuccess(response) {
            let that = this;
            if(response.code == 200){
                that.applyForm3.checkReport = response.obj[0].sid;
                that.$message({
                message: "查重报告"+response.msg,
                duration: 2000,
                showClose: true,
                type: "success",
                offset: 100,
                });
            }else{
                that.$message({
                message:response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
        },
        // 图片上传成功钩子
        imageSuccess(response) {
            let that = this;
            // that.applyForm.checkReport = response.obj[0].resourcePath;
            that.$message({
              message: "图片"+response.msg,
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
        },
        expertOpinionSubmitUpload(){
            this.dataForm.data = this.userData;
            if(this.isEdit){
                this.dataForm.submitId = "";
            }
            this.$refs.expertOpinionUpload.submit();
        },
        unitOpinionSubmitUpload(){
            this.dataForm.data = this.userData;
            if(this.isEdit){
                this.dataForm.submitId = "";
            }
            this.$refs.unitOpinionUpload.submit();
        },
        commitmentSubmitUpload(){
            this.dataForm.data = this.userData;
            if(this.isEdit){
                this.dataForm.submitId = "";
            }
            this.$refs.commitmentUpload.submit();
        },
        manuscriptSubmitUpload(){
            this.dataForm.data = this.userData;
            if(this.isEdit){
                this.dataForm.submitId = "";
            }
            this.$refs.manuscriptUpload.submit();
        },
        checkReportSubmitUpload(){
            this.dataForm.data = this.userData;
            if(this.isEdit){
                this.dataForm.submitId = "";
            }
            this.$refs.checkReportUpload.submit();
        },
        imageSubmitUpload(){
            // this.$refs.imageUpload.submit();
            const needUploadFiles = this.imgFileList.filter(item => {
                return item.raw && !item.isUploaded;
            });
            if (!this.imgFileList.length) {
                this.$message.warning('请先选择文件');
                return;
            }
            const formData = new FormData();
            needUploadFiles.forEach(item => {
                if (item.raw) {
                    formData.append('upfiles', item.raw);
                }
            });
            formData.append('data', this.userData); // 业务类型，1为征稿附件上传
            let that = this;
            $.ajax({
                url: '/zxzg/api/vh/free/upload/attachments',
                type: 'POST',
                data: formData,
                processData: false, // jQuery上传FormData必须关闭这两个
                contentType: false,
                dataType: 'json',
                success: function(res){
                    if(res.code === 200){
                        that.$message.success('上传成功');
                        res.obj.forEach(item => {
                            that.imgContentList.push(item);
                        });
                                // 给刚才上传成功的文件打上已上传标记，下次不再重复上传
                        let idx = 0;
                        that.imgFileList.forEach(fileItem => {
                        if(fileItem.raw && !fileItem.isUploaded && idx < res.obj.length){
                            fileItem.isUploaded = true;
                            // 绑定oldName，用于删除过滤匹配
                            fileItem.oldName = fileItem.name;
                            idx++;
                        }
                        })
                    }else{
                        that.$message.error(res.msg || '上传失败');
                    }
                },
                error: function(err){
                    that.$message.error('接口请求失败');
                    console.error(err)
                }
            })
        },
        // 保存征稿
        saveManuscript(){
            // let that = this;
            // if(this.roleResult.length > 0){
            //     this.applyForm1.joinRole = this.roleResult.toString();
            // }
            // 判断当前是否可保存
            $.ajax({
                url: '/zxzg/api/vh/free/act/submitInfo/check',
                type: "POST",
                dataType: "json",
                data:{
                    actId: this.actId,
                    data: this.userData,
                },
                error: (xhr) => {
                    if (xhr.status == 401) window.location.reload();
                    else console.error('请求失败',xhr);
                },
                success: (data) => {
                    if(data.code === 200) {
                        if(!data.obj.has){
                            if(this.applyForm1.isJoin == 'Y'){
                                this.applyForm1.joinRole = this.roleResult.toString();
                            }else if(this.applyForm1.isJoin == 'N'){
                            // 直接删除两个属性
                                delete this.applyForm1.joinName;
                                delete this.applyForm1.joinRole;
                            }
                            this.applyForm = Object.assign({}, this.applyForm1, this.applyForm2, this.applyForm3,this.applyForm4)
                            this.applyForm.coauthors = this.collaboratorsTable
                            localStorage.setItem('historyData', JSON.stringify(this.applyForm));
                            localStorage.setItem('expertOpinionFileList', JSON.stringify(this.expertOpinionFileList));
                            localStorage.setItem('unitOpinionFileList', JSON.stringify(this.unitOpinionFileList));
                            localStorage.setItem('commitmentFileList', JSON.stringify(this.commitmentFileList));
                            localStorage.setItem('manuscriptFileList', JSON.stringify(this.manuscriptFileList));
                            localStorage.setItem('checkReportFileList', JSON.stringify(this.checkReportFileList));
                            if(this.imgContentList.length > 0){
                                this.imgFileList = [];
                                this.imgContentList.forEach(item=>{
                                    this.imgFileList.push({
                                        name: item.oldName,
                                        url: this.resourceUrl +item.resourcePath,
                                    })
                                })
                            }
                            localStorage.setItem('imgFileList', JSON.stringify(this.imgFileList));
                            localStorage.setItem('collaboratorsTable', JSON.stringify(this.collaboratorsTable));
                            this.$message({
                                message: "征稿信息已成功缓存",
                                duration: 2000,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                        }else if(!data.obj.canSave){
                            this.$alert('当前状态不可进行保存修改，请至个人中心查看审核状态。', '提示', {
                                confirmButtonText: '确定',
                                customClass: 'logoutAlertBox',
                                type: 'warning',
                                center: true,
                                callback: () => {
                                    window.location.href = this.bkwWeb + '/ecph/member/zxzg?current=memberZxzg&SiteID=1';
                                }
                            });
                        }else if(!this.isEdit && data.obj.has){
                            this.$alert('您已经提交过该活动了，当前状态不可进行保存修改，请至个人中心查看审核状态。', '提示', {
                                confirmButtonText: '确定',
                                customClass: 'logoutAlertBox',
                                type: 'warning',
                                center: true,
                                callback: () => {
                                    window.location.href = this.bkwWeb + '/ecph/member/zxzg?current=memberZxzg&SiteID=1';
                                }
                            });
                        }else{
                            if(this.applyForm1.isJoin == 'Y'){
                                this.applyForm1.joinRole = this.roleResult.toString();
                            }else if(this.applyForm1.isJoin == 'N'){
                            // 直接删除两个属性
                                delete this.applyForm1.joinName;
                                delete this.applyForm1.joinRole;
                            }
                            this.applyForm = Object.assign({}, this.applyForm1, this.applyForm2, this.applyForm3,this.applyForm4)
                            this.applyForm.coauthors = this.collaboratorsTable
                            localStorage.setItem('historyData', JSON.stringify(this.applyForm));
                            localStorage.setItem('expertOpinionFileList', JSON.stringify(this.expertOpinionFileList));
                            localStorage.setItem('unitOpinionFileList', JSON.stringify(this.unitOpinionFileList));
                            localStorage.setItem('commitmentFileList', JSON.stringify(this.commitmentFileList));
                            localStorage.setItem('manuscriptFileList', JSON.stringify(this.manuscriptFileList));
                            localStorage.setItem('checkReportFileList', JSON.stringify(this.checkReportFileList));
                            if(this.imgContentList.length > 0){
                                this.imgFileList = [];
                                this.imgContentList.forEach(item=>{
                                    this.imgFileList.push({
                                        name: item.oldName,
                                        url: this.resourceUrl +item.resourcePath,
                                    })
                                })
                            }
                            localStorage.setItem('imgFileList', JSON.stringify(this.imgFileList));
                            localStorage.setItem('collaboratorsTable', JSON.stringify(this.collaboratorsTable));
                            this.$message({
                                message: "征稿信息已成功缓存",
                                duration: 2000,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                        }
                        // if(data.obj.canSave){
                           
                        // }else{
                        //     this.$alert('当前状态不可进行保存修改，请至个人中心查看审核状态。', '提示', {
                        //         confirmButtonText: '确定',
                        //         customClass: 'logoutAlertBox',
                        //         type: 'warning',
                        //         center: true,
                        //         callback: () => {
                        //             window.location.href = this.bkwWeb + '/ecph/member/zxzg?current=memberZxzg&SiteID=1';
                        //         }
                        //     });
                        // }
                    }else{
                        this.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                        });                    
                    }
                }
            })
            
        },
        handleImgFileChange(file, fileList) {
            // fileList是组件原生实时完整列表，直接赋值覆盖我们绑定的数组
            this.imgFileList = [...fileList]; // 浅拷贝切断引用冲突
        },

        handleNativeFileChange() {
            setTimeout(() => {
                if (this.imgFileList.length > 0 && !this.isUploading) {
                    const needUploadFiles = this.imgFileList.filter(item => {
                        return item.raw && !item.isUploaded;
                    });
                    if (needUploadFiles.length > 0) {
                        this.autoBatchUpload();
                    }
                }
            }, 500);
        },

        // 自动批量上传方法
        autoBatchUpload() {
            if (this.isUploading) {
                return;
            }
            const needUploadFiles = this.imgFileList.filter(item => {
                return item.raw && !item.isUploaded;
            });

            // 如果没有需要上传的文件，直接返回
            if (needUploadFiles.length === 0) {
                return;
            }
            this.isUploading = true;
            const formData = new FormData();
            needUploadFiles.forEach(item => {
                if (item.raw) {
                    formData.append('upfiles', item.raw, item.name);
                }
            });
            formData.append('data', this.userData);

            let that = this;
            $.ajax({
                url: '/zxzg/api/vh/free/upload/attachments',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function(res) {
                    if (res.code === 200) {
                        that.$message.success('上传成功');
                        that.submitFlag = true;
                        // 保存上传结果
                        res.obj.forEach(item => {
                            that.imgContentList.push(item);
                        });

                        // 标记已上传的文件
                        let idx = 0;
                        that.imgFileList.forEach(fileItem => {
                            if (fileItem.raw && !fileItem.isUploaded && idx < res.obj.length) {
                                fileItem.isUploaded = true;
                                fileItem.oldName = fileItem.name;
                                fileItem.status = 'success';
                                idx++;
                            }
                        });

                        that.imgFileList = [...that.imgFileList];
                    } else {
                        that.imgFileList = that.imgFileList.filter(item => item.isUploaded);
                        that.$message.error(res.msg || '上传失败');
                    }
                },
                error: function(err) {
                    that.imgFileList = that.imgFileList.filter(item => item.isUploaded);
                    that.$message.error('接口请求失败');
                    console.error(err);
                },
                complete: function() {
                    that.isUploading = false;
                }
            });
        },
        handleExpertOpinionFileChange(file, fileList) {
            // fileList是组件原生实时完整列表，直接赋值覆盖我们绑定的数组
            this.expertOpinionFileList = [...fileList]; // 浅拷贝切断引用冲突
              // 文件列表为空 → 清空表单sid
            if (this.expertOpinionFileList.length === 0) {
                delete this.applyForm3.expertOpinion;
                localStorage.setItem('expertOpinionFileList', '');
            }
        },
        handleUnitOpinionFileChange(file, fileList) {
            // fileList是组件原生实时完整列表，直接赋值覆盖我们绑定的数组
            this.unitOpinionFileList = [...fileList]; // 浅拷贝切断引用冲突
            if (this.unitOpinionFileList.length === 0) {
                delete this.applyForm3.unitOpinion;
                localStorage.setItem('unitOpinionFileList', '');
            }
        },
        handleCommitmentFileChange(file, fileList) {
            // fileList是组件原生实时完整列表，直接赋值覆盖我们绑定的数组
            this.commitmentFileList = [...fileList]; // 浅拷贝切断引用冲突
            if (this.commitmentFileList.length === 0) {
                delete this.applyForm3.commitment;
                localStorage.setItem('commitmentFileList', '');
            }
        },
        handleManuscriptFileChange(file, fileList) {
            // fileList是组件原生实时完整列表，直接赋值覆盖我们绑定的数组
            this.manuscriptFileList = [...fileList]; // 浅拷贝切断引用冲突  
            if (this.manuscriptFileList.length === 0) {
                delete this.applyForm3.manuscript;
                localStorage.setItem('manuscriptFileList', '');
            }
        },
        handleCheckReportFileChange(file, fileList) {
            // fileList是组件原生实时完整列表，直接赋值覆盖我们绑定的数组
            this.checkReportFileList = [...fileList]; // 浅拷贝切断引用冲突
            if (this.checkReportFileList.length === 0) {
                delete this.applyForm3.checkReport;
                localStorage.setItem('checkReportFileList', '');
            }
        },
            // 删除表格
        deleteTable(row) {
           this.collaboratorsTable = this.collaboratorsTable.filter((item) => item != row);
        },
        handleExpertOpinionRemove(file, fileList) {
            this.expertOpinionFileList = [...fileList];
            // 同步清空表单里存的文件id
            delete this.applyForm3.expertOpinion;
            localStorage.setItem('expertOpinionFileList', '');
        },
        // 单位意见删除
        handleUnitOpinionRemove(file, fileList) {
            this.unitOpinionFileList = [...fileList];
            delete this.applyForm3.unitOpinion;
            localStorage.setItem('unitOpinionFileList', '');
        },
        // 承诺书删除
        handleCommitmentRemove(file, fileList) {
            this.commitmentFileList = [...fileList];
            delete this.applyForm3.commitment;
            localStorage.setItem('commitmentFileList', '');
        },
        // 书稿删除
        handleManuscriptRemove(file, fileList) {
            this.manuscriptFileList = [...fileList];
            delete this.applyForm3.manuscript;
            localStorage.setItem('manuscriptFileList', '');
        },
        // 查重报告删除
        handleCheckReportRemove(file, fileList) {
            this.checkReportFileList = [...fileList];
            delete this.applyForm3.checkReport;
            localStorage.setItem('checkReportFileList', '');
        },
        // 图片上传删除
        handleImgRemove(file, fileList) {
            this.imgFileList = [...fileList];
            if (this.imgFileList.length === 0) {
                this.applyForm4.imageIds = '';
            } else {
                // 1. 先提取 imgFileList 里所有 name 值集合，方便快速匹配
                const nameSet = new Set(this.imgFileList.map(file => file.name));

                // 2. 过滤 imgContentList：只保留 oldName 存在于 nameSet 的项
                this.imgContentList = this.imgContentList.filter(item => {
                    return nameSet.has(item.oldName);
                });
            }
        },
         getUrlParam(name) {
            var search = window.location.search.slice(1);
            var params = new URLSearchParams(search);
            let val = params.get(name);
            if (!val) return '';
            let fixStr = val.replace(/ /g, '+');
            return decodeURIComponent(fixStr);
        },
        // 校验第一页
        checkPage1() {
        return new Promise(resolve => {
            this.$refs.applyForm1.validate(valid => {
            resolve(valid);
            });
        });
        },
        // 校验第二页
        checkPage2() {
        return new Promise(resolve => {
            this.$refs.applyForm2.validate(valid => {
            resolve(valid);
            });
        });
        },
        // 校验第三页
        checkPage3() {
            return new Promise(resolve => {
                this.$refs.applyForm3.validate(valid => {
                resolve(valid);
                });
            });
        },
        handleImgProgress() {
            this.submitFlag = false;
        },
        }
  }
</script>